import { validationMessages } from '../common/constants';

export const validateMessageMax = (max: string) => {
	return `${validationMessages.max_value} ${max}`;
};

export const validateExactLengthMessage = (length_message: string) => {
	return `${validationMessages.exact_length} ${length_message}`;
};

export const atMostMessaege = (message: string) => {
	return `${validationMessages.at_most} ${message}`;
};

export const decimalDigitsRegex = (maxInt: number, maxDec: number) => {
	return new RegExp(`^\\d{1,${maxInt}}(?:\\.\\d{1,${maxDec}})?$`);
};
